import React from "react";
import {
  FlippingCard,
  FlippingCardBack,
  FlippingCardFront,
} from "react-ui-cards";

import { Row, Col, Container } from "react-bootstrap";

import "./css/Team.css";
import ParticleBackground from "./ParticleBackground";

const Team = () => {
  return (
    <div className="bg">
      <Container fluid="sm">
        <h1
          style={{
            fontFamily: "Bebas Neue",
            textAlign: "center",
            color: "white",
          }}
        >
          {" "}
          Core 2022-23
        </h1>
        <Row
          className="justify-content-md-center"
          style={{ marginTop: "50px", marginLeft: "5%" }}
        >
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/japneet_1505/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:jkaur2_be20@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front "
                  style={{
                    backgroundImage: "url(images/2022/Japneet.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>General Secretary</p>
                    <span>Japneet Kaur</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/aviral_25_/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:anagpal2_be20@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Aviral.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Joint Secretary</p>
                    <span>Aviral Nagpal</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/sedha_anntt/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:sidsachdeva09@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Sidhant.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Joint Secretary</p>
                    <span>Sidhant Sachdeva</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/ayush_goyal12"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:agoyal5_be20@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Ayush.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Documentation Head</p>
                    <span>Ayush Goyal</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/dsehdev18/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:dshedev_be20@thapar.edu?subject=Subject&body=Your lovely boy here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Devesh.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p> Travel Director</p>
                    <span> Devesh Sehdev</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/devanshi.arora/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>

                    <a
                      onClick={() => {
                        window.location.href = `mailto:darora_be20@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Deva.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Travel Director</p>
                    <span>Devanshi Arora</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/anushka__chaudhry/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:nushuchaudhry@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Anushka.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Media Head</p>
                    <span>Anushka Chaudhry</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/avidang__/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:pdang_btech20@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Piyush.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Media Head</p>
                    <span> Piyush Dang</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/deepdhruv_001 /"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:Ddhruvdeep_be20@thapar.edu ?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Dhruvdeep.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Logistics Head</p>
                    <span>Dhruvdeep Singh</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/deepanmolkaur/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a>
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Deep.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Logistics Head</p>
                    <span>Deep Anmol Kaur</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/smriddhi.arora/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:smriddhiarora1806@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Smriddhi.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>PR Head</p>
                    <span>Smriddhi Arora</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/ishnoorkohli/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:Ikohli_be20@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/2022/Ishnoor.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>PR Head</p>
                    <span>Ishnoor Kohli</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
        </Row>
      </Container>

      <Container fluid="sm">
        <Row
          className="justify-content-md-center"
          style={{ marginTop: "50px", marginLeft: "5%" }}
        >
          <h1
            style={{
              fontFamily: "Bebas Neue",
              textAlign: "center",
              color: "white",
            }}
          >
            {" "}
            Super Core 2021-22
          </h1>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/justahappyguy_/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:karora_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front "
                  style={{
                    backgroundImage: "url(images/kartik.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>General Secretary</p>
                    <span>Kartik Arora</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/otaku_geek_natsu/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:dkhanna1_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/daksh.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Joint Secretary</p>
                    <span>Daksh Khanna</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/_sameer_995/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:sameer.singla44@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/sameer.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Joint Secretary</p>
                    <span>Sameer Singla</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a href={URL} style={{ color: "white" }}>
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a href={URL} style={{ color: "white" }}>
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/tejas.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Finance Head</p>
                    <span>Tejas Sharma</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/nishit.05/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:ngupta7_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/nishit.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Finance Head</p>
                    <span>Nishit Gupta</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/ramyasrini.24/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>

                    <a
                      onClick={() => {
                        window.location.href = `mailto:ramyasrini.2401@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/ramya.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Media Head</p>
                    <span>Ramya Srinivasan</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/yashi2020_/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:bansal.yashika2001@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/yashika.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Media Head</p>
                    <span>Yashika Bansal</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/gurichathaaa/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:gurichatha01@gmail.com?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/gurmehardeep.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Hospitality Head</p>
                    <span>Gurmehardeep Singh</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/skhandelwal01/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:skhandelwal_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/sakshi.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Hospitality Head</p>
                    <span>Sakshi Khandelwal</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/in.the.life.of.arsh/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:asaini_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/arsh.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Logistics Head</p>
                    <span>Arshpreet Singh</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/pransh____14/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:ppaul_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/pransh.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Documentation Head</p>
                    <span>Pransh Paul</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              >
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/satnaaaammm_/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a href={URL} style={{ color: "white" }}>
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/satnam.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Core Member</p>
                    <span>Satnam Tuteja</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a href={URL} style={{ color: "white" }}>
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      href={"https://www.instagram.com/ishparmar/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front"
                  style={{
                    backgroundImage: "url(images/ishita.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p>Core Member</p>
                    <span>Ishita Parmar</span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Team;
